/**
 * Shared helper utilities
 */

/**
 * Calculate age from birthdate
 * @param {string} birthdate - Date string in YYYY-MM-DD format
 * @returns {string|null} Age formatted as "Xy Ym" or null if no birthdate
 */
export const calculateAge = (birthdate) => {
  if (!birthdate) return null;
  try {
    const birthDate = new Date(birthdate + 'T00:00:00');
    const today = new Date();
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    
    if (months < 0) {
      years--;
      months += 12;
    }
    
    // Adjust for day of month
    if (today.getDate() < birthDate.getDate()) {
      months--;
      if (months < 0) {
        years--;
        months += 12;
      }
    }
    
    if (years === 0) {
      return `${months}m`;
    }
    return `${years}y ${months}m`;
  } catch (e) {
    return null;
  }
};

/**
 * Format a date string for display
 * @param {string} dateStr - Date string
 * @returns {string} Formatted date
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    return new Date(dateStr + 'T00:00:00').toLocaleDateString();
  } catch (e) {
    return dateStr;
  }
};
